<template>
    <div>
        <div v-if="!taken_cbt">
            <div class="instructions" v-show="!test.started">
                <p><b>Time:</b> {{cbt.time_allowed}} minutes</p>
                <p><b>Number of Questions:</b> {{questions.length}}</p>

                <h6><b>INSTRUCTIONS TO CANDIDATES</b></h6>

                <p>{{cbt.instruction}}</p>
                <hr />
                <ul>
                    <li v-if="questions.length > '1'">There are {{questions.length}} questions in this test.</li>
                    <li v-else>There is {{questions.length}} question in this test.</li>
                    <li>The test clock will show you how much time you have left.</li>
                </ul>
                <div style="text-align: center; margin-top: 50px;" v-show="test.status !== 'ended'">
                    <button class="btn btn-md btn-success" v-on:click="startTest">Start Test</button>
                </div>
            </div>

            <div class="counter" v-show="countdown.status == 'started'">
                <span class="title">{{countdown.text}}</span>
                <h1>{{countdown.steps}}</h1>
                <p class="title">seconds</p>
            </div>
            
            <div class="questions" v-show="test.status == 'started'">
                
                <div v-if="questions.length < 1">
                    <p style="font-size: 16px;">Sorry, no CBT questions has been added for this opening. Please contact administrator.</p>
                </div>

                <div v-else>

                    <div class="test-clock pull-right">
                        <h5>Time Left: {{time_left}}</h5>
                    </div>
                    <br>
                    <div v-for="(question, index) in questions">
                        <div v-if="test.current_question == (index + 1)">
                            <form v-on:submit.prevent="">

                                <!-- QUESTION TYPE: SITUATIONAL JUDGEMENT -->
                                <div v-if="question.questiontype == 'sj'" class="single-question">
                                    <blockquote class="blockquote">
                                        <b>Question:</b>
                                        <p>{{question.questioncontent}}</p>
                                    </blockquote>
                                    <div class="question-options">
                                        <p v-for="(option, option_index) in question.options">
                                            <b>Option {{option_index + 1}}: </b>{{option}}
                                        </p>
                                    </div>
                                    <div class="question-answer">
                                        <div class="row mt-5">
                                            <div v-for="(tag, tag_index) in question.answer_tags" class="col-lg-3">
                                                <b>{{tag}}</b>
                                                <p v-for="(option, option_index) in question.options" class="mt-2">
                                                    <input type="radio" v-bind:name="'tag_' + tag_index + '_options'" v-bind:value="option_index" v-model="test_answers[index].answer[tag_index]" />
                                                    Option {{option_index + 1}}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- END QUESTION TYPE: SITUATIONAL JUDGEMENT -->

                                <!-- QUESTION TYPE: ORDERED ANSWER AND MULTIPLE ANSWER -->
                                <div v-else-if="question.questiontype == 'oa' || question.questiontype == 'ma'" class="single-question">
                                    <blockquote class="blockquote">
                                        <b>Question:</b>
                                        <p>{{question.questioncontent}}</p>
                                    </blockquote>
                                    <div class="question-options">
                                        <p v-for="(option, option_index) in question.options">
                                            <b>Option {{option_index + 1}}: </b>{{option}}
                                        </p>
                                    </div>
                                    <div class="question-answer">
                                        <p v-if="question.questiontype == 'ma'"><b>Correct Answers:</b></p>
                                        <p v-else><b>Check the answers in the right order:</b></p>
                                        <div class="question_options mt-2">
                                            <p v-for="(option, option_index) in question.options">
                                                <input type="checkbox" v-bind:name="'question_' + index + '_options'" v-model="test_answers[index].answer" v-bind:value="option_index" />
                                                Option {{option_index + 1}}
                                            </p>
                                        </div>
                                        <div v-if="test_answers[index].answer.length > 1 && question.questiontype == 'oa'">
                                            <p class="mt-2"><b>Your Answer:</b></p>
                                            <span v-for="(i, i_index) in test_answers[index].answer">
                                                <p>
                                                    <b>{{i_index + 1}} >>> </b>{{question.options[i]}}
                                                </p>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <!-- END QUESTION TYPE: ORDERED ANSWER AND MULTIPLE ANSWER -->

                                <!-- QUESTION TYPE: LONG TEXT -->
                                <div v-else-if="question.questiontype == 'lt'">
                                    <blockquote class="blockquote">
                                        <b>Question:</b>
                                        <p>{{question.questioncontent}}</p>
                                    </blockquote>
                                    <div class="question-answer">
                                        <b>Answer</b>
                                        <textarea class="form-control mt-2" style="height: 200px;" v-model="test_answers[index].answer[0]" placeholder="Your answer..."></textarea>
                                    </div>
                                </div>
                                <!-- END QUESTION TYPE: LONG TEXT -->

                                <!-- QUESTION TYPE: SHORT TEXT -->
                                <div v-else-if="question.questiontype == 'st'">
                                    <blockquote class="blockquote">
                                        <b>Question:</b>
                                        <p>{{question.questioncontent}}</p>
                                    </blockquote>
                                    <div class="question-answer">
                                        <b>Answer to blanks</b>
                                        <div class="answer-inputs row">
                                            <div class="col-lg-3" v-for="(input, input_index) in question.inputs">
                                                <input type="text" class="form-control" v-model="test_answers[index].answer[input_index]" v-bind:placeholder="'Blank ' + (input_index + 1)" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- END QUESTION TYPE: SHORT TEXT -->

                                <!-- QUESTION TYPE: SINGLE ANSWER -->
                                <div v-else-if="question.questiontype == 'sa'">
                                    <blockquote class="blockquote">
                                        <b>Question:</b>
                                        <p>{{question.questioncontent}}</p>
                                    </blockquote>
                                    <div class="question-options">
                                        <p v-for="(option, option_index) in question.options">
                                            <input type="radio" v-bind:name="'question_' + index + '_options'" v-bind:value="option_index" v-model="test_answers[index].answer[0]" />
                                            {{option}}
                                        </p>
                                    </div>
                                </div>
                                <!-- END QUESTION TYPE: SINGLE ANSWER -->  
                                
                                <div class="action_buttons mt-5">
                                    <button type="button" class="btn btn-primary pull-left" v-on:click="prevQuestion"><i class="icofont icofont-arrow-left"></i> Previous</button>

                                    <button type="button" class="btn btn-primary pull-right" v-on:click="nextQuestion">Next <i class="icofont icofont-arrow-right"></i></button>
                                </div>

                               <!--  <button v-on:click="checktest" type="button">Test</button> -->

                            </form>
                                
                        </div>
                    </div>
                </div>
                    
            </div>
            <div class="final" v-show="test.status == 'ended'">
                <h5>{{post_status}}</h5>
            </div>
        </div>

        <div class="final" v-else>
            <h5>You have taken this test already.</h5>
        </div>

    </div>
</template>
<style scoped>
    .final{
        text-align: center;
        margin-top: 50px;
    }
    td {
        white-space: normal !important; 
        word-wrap: break-word;  
    }
    table {
        table-layout: fixed;
    }
    table tr:last-child{
        display: none;
    }
</style>
<script>
export default{
    name: 'CBT',
    data(){
        return{
            post_status: '',
            cbt: [],
            questions: [],
            test: {
                status: '',
                start_time: '',
                end_time: '',
                questions_answered: '',
                total_questions: '',
                current_question: 1,
                button_text: 'Next'
            },
            countdown: {
                steps: 3,
                text: 'Test starts in:',
                status: ''
            },
            card_title: 'Introduction',
            test_answers: [],
            time_left: '',
            demo_time: '10',
            taken_cbt: true
        }
    },
    mounted(){

        this.checkCbt()

        this.testTimer()
    },
    methods: {
        startTest: function(){
            this.test.started = true
            this.test.total_questions = this.questions.length
            this.showCountdown()
        },

        showCountdown: function(){

            this.countdown.status = 'started'
            this.card_title = 'Starting...'
            var s = setInterval(()=>{
                //Countdown till steps = 0
                if(this.countdown.steps > 0){
                    this.countdown.steps = this.countdown.steps - 1
                } else {
                    //When steps = 0, timer has ended
                    this.countdown.status = 'ended'

                    //test started
                    this.test.status = 'started'

                    this.card_title = 'Test in progress.'

                    var time = this.getTime()

                    console.log('Test started at '+time+'...')

                    let tt = this.demo_time * 60

                    this.testTimer(tt)

                    clearInterval(s)
                }
            }, 1000)
        },

        testTimer: function(duration){

            var timer = duration, minutes, seconds

            if(this.questions.length > 0){

                var t = setInterval(()=> {

                    minutes = parseInt(timer / 60, 10)
                    seconds = parseInt(timer % 60, 10)

                    minutes = minutes < 10 ? "0" + minutes : minutes
                    seconds = seconds < 10 ? "0" + seconds : seconds

                    this.time_left = minutes + ":" + seconds

                    if (--timer < 0) {

                        //Countdown is done, show alert and end test
                        this.$swal.fire({
                            title: "Time up", 
                            text: "You have exhausted the allowed time for this test, your answers will now be submitted and you will be logged out.",
                            type: 'warning',
                            showConfirmButton: false,
                            showCancelButton: false,
                            allowOutsideClick: false
                        })

                        setTimeout(()=>{
                            this.submitTest()
                        }, 2000)

                        setTimeout(()=>{
                            this.$store.dispatch('logout')
                            window.location.reload()
                        }, 5000)

                        clearInterval(t)
                    }

                }, 1000)
            }
                
        },
    
        nextQuestion: function(){
            if(this.test.current_question < this.test.total_questions - 1){
                this.test.button_text = "Finish"
            }
            if(this.test.current_question < this.test.total_questions){
                this.test.current_question++
            } else {
                this.test.status = 'ended'
                this.submitTest()
            }
        },

        prevQuestion: function(){
            if(this.test.current_question > 1){
                this.test.current_question--
            }
        },

        getTime: function(offset = 0){

            if(offset > 0){
                var d = new Date()
                d = new Date(d.getTime() + offset*60000);
            } else {
                var d = new Date()
            }
            
            var h = (d.getHours().toString().length > 1) ? d.getHours() : ('0' + d.getHours())
            var m = (d.getMinutes().toString().length > 1) ?  d.getMinutes() : ('0' +  d.getMinutes())
            var s = (d.getSeconds().toString().length > 1) ? d.getSeconds() : ('0' + d.getSeconds())

            return h + ':' + m + ':' + s
        },

        getCbt: function(){

            var cbt = {
                what: 'GetCBT',
                params: {
                    joblistingid: this.$store.getters.user_data.data.joblisting_id
                }
                //id: '10'
            }

            this.$socket.makeGetRequest(cbt)
                .then((response)=>{
                    if(response.type == 'GetCBT'){
                        console.log(response)
                        if(response.data !== undefined){
                            this.cbt = response.data[0]
                            this.demo_time = this.cbt.time_allowed
                            this.questions = this.castShortTextInput(response.data[0].cbtquestions)
                            this.test_answers = this.questions.map(
                                function(x){
                                    return {"questionid": x.questionid, "answer": []}
                                }
                            )
                            this.$swal.close()
                        }
                    }
                })
                .catch((e)=>{
                    if(e.message === "You cant take same test twice"){
                        this.test.status == 'ended'
                        var html_text = "<p style='font-size: 15px;'>It appears you have taken this test before, you cannot take a test more than once. Please contact the administrator if you believe this is an error.</p><br /><a class='btn btn-primary' href='/stage1'>Back to home</a>";
                        this.$swal.fire({
                            type: "info",
                            title: "<h4>Test Taken</h4>", 
                            html: html_text,  
                            showConfirmButton: false,
                            showCancelButton: false,
                            width: '500px',
                            allowOutsideClick: false
                        })
                    } else {
                        console.log(e)
                    }
                })
        },

        castShortTextInput: function(question_array){
            /*
                This function should not have to exist. The "inputs" in of the short-text type
                of question is always a string and we want to loop over its range so we need to convert it to
                an integer, that's the whole reason this function exists.
            */

            var sorted = []

            var array_count = question_array.length

            for(var i=0;i<array_count;i++){
                if(question_array[i].questiontype == 'st'){
                    question_array[i].inputs = parseInt(question_array[i].inputs)
                }
                sorted.push(question_array[i])
            }

            return sorted
        },

        populateAnswersArray: function(x){
            /*
                x represents the question array.
                We want to populate the this.answers array with the format:
                {
                    questionid: **,
                    answer: []
                }
                Depending on the question type
            */
        },

        submitTest: function(){

            let data = {
                application_id: this.$store.getters.user_data.data.id,
                cbtrecord: this.test_answers
            }

            //console.log(data)

            var test_data = {
                what: 'SubmitCbt',
                data: data
            }

            this.$socket.makePostRequest(test_data)
                .then((response)=>{
                    if(response.type == "SubmitCbt"){
                        this.$swal.fire('Success', 'You have successfully completed this test.', 'success')
                        this.post_status = "Test completed. Please note that you will not be able to take this test again. You will be contacted if you qualify for next stage."
                        //console.log(response)
                    }
                })
                .catch((error)=>{
                    console.log(error.data.meessage)
                    this.$swal.fire('An error occured', error.data.message, 'error')
                    this.post_status = "You have previously completed this test, you cannot take a test twice."
                })
        },

        checktest: function(){
            //console.log(this.test_answers)
        },

        checkCbt: function(){

            var applicant = {
                what: 'CheckIfApplicantHasTakenTest',
                data: {
                    applicant_id: this.$store.getters.user_data.data.id
                }
            }

            this.$socket.makePostRequest(applicant)
                .then((response)=>{
                    if(response.data.data){
                        this.taken_cbt = true
                    } else {
                        this.getCbt()
                        this.taken_cbt = false
                    }
                })
                .catch((error)=>{
                    this.$swal.fire('Error', error.message, 'error')
                })
        }
    },
    computed: {
        counter(){
            return this.test.current_question + '/' + this.test.total_questions
        }
    }
}
</script>